module.exports = __webpack_public_path__ + "img/profile-pic-nature-lover.82334345.jpg";